export const getters = {
  productRecommendationMap: (state) => state.productRecommendationMap,
  optimizerLanguage: (state) => state.optimizerLanguage,
  indexedProductPrices: (state) => state.indexedProductPrices,
  useOneService: (state) => state.useOneService
};
